import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API base URL

// Async thunk for file upload
export const uploadFileToCloudinary = createAsyncThunk(
    'cloudinary/uploadFile',
    async (file, { rejectWithValue }) => {
        console.log(file, "------------------file-----------")
        try {
            const cloudName = 'dxhh84cbh';
            const uploadPresetImage = 'social-media';
            const uploadPresetPDF = 'social-pdfs';
            const uploadPresetVideo = 'social-video';

            let url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;
            const formData = new FormData();
            formData.append("file", file);

            let uploadPreset = 'default';
            let resourceType = 'image';

            // Set the correct upload preset based on file type
            if (file.type.startsWith('image/')) {
                uploadPreset = uploadPresetImage;
            } else if (file.type === 'application/pdf') {
                uploadPreset = uploadPresetPDF;
                url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;
                resourceType = 'raw';
            } else if (file.type.startsWith('video/')) {
                uploadPreset = uploadPresetVideo;
                url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;
                resourceType = 'raw';
            }


            formData.append("upload_preset", uploadPreset);

            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params: {
                    resource_type: resourceType
                }
            });

            return { url: response.data.secure_url, public_id: response.data.public_id, filetype: file.type };
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Async thunk for deleting a file
export const deleteFileFromCloudinary = createAsyncThunk(
    'cloudinary/deleteFile',
    async (publicId, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BASE_URL}/cloudinary/delete`, { publicId });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Async thunk for checking image type
export const checkImageType = createAsyncThunk(
    'cloudinary/checkImageType',
    async (url, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BASE_URL}/imgtype`, { imgurl: url });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
